// src/context/NotificationContext.js
import React, { createContext, useState, useEffect, useCallback } from 'react';
import api from '../services/ApiService';
import { getUserIdFromToken } from '../utils/getUserIdFromToken';

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);

  const refetchNotifications = useCallback(async () => {
    const userId = getUserIdFromToken();
    if (!userId) return;

    try {
      const response = await api.get(`/notifications/user/${userId}`);
      const data = response.data.notifications || response.data;
      const unread = data.filter((notif) => !notif.read);

      setNotifications(data);
      setNotificationCount(unread.length);

      if (process.env.NODE_ENV === 'development') {
        console.log(`[NotificationContext] 🔁 Refetched ${data.length} notifications (${unread.length} unread)`);
      }
    } catch (error) {
      console.error('[NotificationContext] ❌ Error refetching notifications:', error);
    }
  }, []);

  // ⏱️ Fetch sekali saat mount
  useEffect(() => {
    refetchNotifications();
  }, [refetchNotifications]);

  const markAsRead = async (id) => {
    try {
      await api.post(`/notifications/mark-as-read/${id}`);
      setNotifications((prev) =>
        prev.map((notif) =>
          notif._id === id ? { ...notif, read: true } : notif
        )
      );
      setNotificationCount((prev) => prev - 1);
    } catch (error) {
      console.error('[NotificationContext] ❌ Error marking as read:', error);
    }
  };

  const deleteNotification = async (id) => {
    try {
      const target = notifications.find((n) => n._id === id);
      await api.delete(`/notifications/${id}`);
      setNotifications((prev) => prev.filter((n) => n._id !== id));
      if (target && !target.read) {
        setNotificationCount((prev) => prev - 1);
      }
    } catch (error) {
      console.error('[NotificationContext] ❌ Error deleting notification:', error);
    }
  };

  return (
    <NotificationContext.Provider
      value={{
        notifications,
        notificationCount,
        markAsRead,
        deleteNotification,
        refetchNotifications, // ⬅️ Tambahkan ke context
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
